import { RootState } from '../../config';
import { IAccountState } from './types';

export const selectAccount = (state: RootState): IAccountState => state.account;
